import { ValueFormHealth } from "../../../../../../constants/health";

export const DefaultValueFormHealth = (isDisabled: boolean = false): ValueFormHealth => {
  return {
    value: "",
    errorCode: "",
    disabled: isDisabled,
    code: "",
  };
};
export const DefaultProfessionData = (): ProfessionData => {
  return {
    value: "",
    errorCode: "",
    disabled: false,
    code: "",
    other: {
      value: "",
      errorCode: "",
      disabled: false,
    },
  };
};

export interface ProfessionData {
  value: string;
  errorCode: string;
  disabled: boolean;
  code: string;
  other: {
    value: string;
    errorCode: string;
    disabled: boolean;
  };
}

export interface LegalRepreDto {
  name: ValueFormHealth;
  lastName1: ValueFormHealth;
  lastName2: ValueFormHealth;
  docType: ValueFormHealth;
  docNumber: ValueFormHealth;
  passportDate: ValueFormHealth;
  relationship: ValueFormHealth;
}

export interface InsuredPersonalDataDto {
  name: ValueFormHealth;
  lastName1: ValueFormHealth;
  lastName2: ValueFormHealth;
  birthDate: ValueFormHealth;
  docType: ValueFormHealth;
  docNumber: ValueFormHealth;
  sex: ValueFormHealth;
  nationality: ValueFormHealth;
  nationalityLabel: string;
  profession: ProfessionData;
  passportDate: ValueFormHealth;
  sameAsTaker: boolean;
  hasLegalRepre?: boolean;
  legalRepre?: LegalRepreDto;
}

export const DefaultLegalReprePersonalData = (): LegalRepreDto => {
  return {
    name: DefaultValueFormHealth(),
    lastName1: DefaultValueFormHealth(),
    lastName2: DefaultValueFormHealth(),
    docType: DefaultValueFormHealth(),
    docNumber: DefaultValueFormHealth(),
    passportDate: DefaultValueFormHealth(),
    relationship: DefaultValueFormHealth(),
  };
};

export const DefaultInsuredPersonalData = (hasLegalRepre?: boolean): InsuredPersonalDataDto => {
  return {
    name: DefaultValueFormHealth(),
    lastName1: DefaultValueFormHealth(),
    lastName2: DefaultValueFormHealth(),
    birthDate: DefaultValueFormHealth(),
    docType: DefaultValueFormHealth(),
    docNumber: DefaultValueFormHealth(),
    sex: DefaultValueFormHealth(),
    nationality: DefaultValueFormHealth(),
    nationalityLabel: "",
    profession: DefaultProfessionData(),
    passportDate: DefaultValueFormHealth(),
    sameAsTaker: false,
    hasLegalRepre: false,
    ...(hasLegalRepre
      ? {
          name: DefaultValueFormHealth(),
          lastName1: DefaultValueFormHealth(),
          lastName2: DefaultValueFormHealth(),
          docType: DefaultValueFormHealth(),
          docNumber: DefaultValueFormHealth(),
          passportDate: DefaultValueFormHealth(),
          relationship: DefaultValueFormHealth(),
        }
      : {}),
  };
};
